// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ExtEnrollmentCreateSiteResultModel {
    'siteId'?: string;
    'siteVerified'?: boolean;
    'createDate'?: Moment;
    'lastUpdateDate'?: Moment;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ExtEnrollmentCreateSiteResultModel>> = [
        {
            "name":     "siteId",
            "baseName": "siteId",
            "type":     "string"
        },
        {
            "name":     "siteVerified",
            "baseName": "siteVerified",
            "type":     "boolean"
        },
        {
            "name":     "createDate",
            "baseName": "createDate",
            "type":     "Date"
        },
        {
            "name":     "lastUpdateDate",
            "baseName": "lastUpdateDate",
            "type":     "Date"
        },
    ];

    static getAttributeTypeMap() {
        return ExtEnrollmentCreateSiteResultModel.attributeTypeMap;
    }
}
